import { render, staticRenderFns } from "./WTHLogo.vue?vue&type=template&id=54e9308d&scoped=true&"
var script = {}
import style0 from "./WTHLogo.vue?vue&type=style&index=0&id=54e9308d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e9308d",
  null
  
)

export default component.exports